module.exports = __webpack_public_path__ + "static/img/A45.40f10e03.jpg";